<div class="mb-3">
  @if (arbetsorderInfoAnteckningarService.activeView === 'Atgard') {
    <rask-arbetsorder-info-atgard-anteckningar>
    </rask-arbetsorder-info-atgard-anteckningar>
  }
  @if (arbetsorderInfoAnteckningarService.activeView === 'Arbetsorder') {
    <rask-arbetsorder-info-arbetsorder-anteckningar>
    </rask-arbetsorder-info-arbetsorder-anteckningar>
  }
</div>